/*
 * @Author: zhengxiaowen 
 * @Date: 2018-08-24 23:55:07 
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-13 01:33:19
 */


import platform from '@/config/platform'

let host = platform.host

let api = {
    // 快码查询
    baseLookupTypeService_find: `${host}/baseServer/baseLookupTypeService/find`
}

export default api;


// WEBPACK FOOTER //
// ./src/page/devDemo2/config/api.js